<div class="defect">
  <h4 class="defect-title">Каталог дефектов</h4>
  <div class="defect-buttons">
    @for (btn of defectButtons; track btn.key) {
      <button
        mat-stroked-button
        color="primary"
        type="button"
        class="btn"
        (click)="handleOpenModal(btn.key)"
      >
        {{ btn.label }}
      </button>
    }
  </div>
</div>
